module.exports = __webpack_public_path__ + "img/ambient-lighting-animations.68e7cdfc.gif";